<template>
	<div class="page">
		<div class="container">
			<!--      <div class="left"></div>-->
			<div class="right">
				<div class="title">绑定手机号</div>
        <div style="display: flex;position: relative;">
          <!-- <img class="ico" slot="prefix" style="width: 16px; height: 26px;z-index: 999999;"
            src="@/assets/tel.png" alt="" /> -->
          <el-select style="width: 160px;outline: none;" v-model="sms_code" placeholder="区号">
            <img class="ico" slot="prefix" style="width: 16px; height: 26px;z-index: 999999;"
                 src="@/assets/tel.png" alt="" />
            <el-option :label="'+'+item.code" :value="item.code" v-for="(item, index) in sms_code_list"
                       :key="index"></el-option>
          </el-select>
          <el-input placeholder="请输入手机号" v-model="tel">
            <!-- <i slot="prefix" class="el-input__icon el-icon-phone-outline"></i> -->
          </el-input>
        </div>
<!--				<div class="item">-->
<!--					<el-input placeholder="请输入手机号" v-model="tel">-->
<!--						&lt;!&ndash; <i slot="prefix" class="el-input__icon el-icon-phone-outline"></i> &ndash;&gt;-->
<!--						<img class="ico" slot="prefix" style="width: 16px; height: 26px" src="@/assets/tel.png"-->
<!--							alt="" />-->
<!--					</el-input>-->
<!--				</div>-->
				<div class="item">
					<el-input placeholder="请输入验证码" v-model.number="code">
						<img class="ico" slot="prefix" style="width: 20px; height: 22px" src="@/assets/pass.png"
							alt="" />
						<span class="second" slot="suffix" @click="getPhoneCode">
							{{ start ? num + "s" : "点击获取验证码" }}
						</span>
					</el-input>
				</div>
				<div class="item" style="text-align: right">
					<el-button class="login" @click="bindingPhoneOpDo">绑定<i class="el-icon-right"
							style="padding-left: 13px; color: #fff"></i></el-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		bindingPhoneOne,
		bindingPhoneOneOp,
    smsCodeList
	} from "@/request/api.js";
	export default {
		data() {
			return {
				tel: "",
				code: "",
				start: false,
				num: 59,
				checked: false,
				fromPath: "",
        sms_code_list: [],
        sms_code: "86",
			};
		},
		created() {
			document.title = '以图绘图印花设计网-绑定手机号';
      this.getSmsCode();
			console.log(window.location.host);
		},
		methods: {
      getSmsCode() {
        smsCodeList({}).then((res) => {
          this.sms_code_list = res.data;
        });
      },
			//获取验证码
			getPhoneCode() {
				if (this.start) {
					return;
				}
				bindingPhoneOne({
					tel: this.tel,
          code:this.sms_code,
				}).then((res) => {
					if (res.code == 200) {
						this.start = !this.start;
						var t = this.num;
						var time = setInterval(() => {
							this.num = t--;
							if (this.num == 0) {
								clearInterval(time);
								this.start = !this.start;
								this.num = 60;
							}
						}, 1000);
					}
					if (res.code == 500) {
						this.$message.error(res.msg);
					}
				});
			},
			//填写验证码确认
			bindingPhoneOpDo() {
				bindingPhoneOneOp({
					tel: this.tel,
					code: this.code,
				}).then((res) => {
					if (res.code == 200) {
						this.$message({
							message: res.msg,
							type: "success",
						});
						localStorage.setItem("is_binding", '1');
						this.$router.go(-1);
					} else {
						this.$message.error(res.msg);
					}
				});
			},
		},
	};
</script>
<style lang="less" scoped>
	.page {
		width: 100%;
		height: 100%;
		background: url("https://www.yituhuitu.com/img/loginBack.png") no-repeat;

		.container {
			width: 500px;
			height: 593px;
			background: #ffffff;
			box-shadow: 0px 11px 23px 1px rgba(0, 0, 0, 0.26);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			display: flex;

			.left {
				width: 530px;
				height: 100%;
				background: url("https://www.yituhuitu.com/img/login.jpg") no-repeat;
				background-size: cover;
			}

			.right {
				width: 360px;
				//   height: 100%;
				//   background: red;
				padding: 47px 80px 29px 80px;
				display: flex;
				flex-direction: column;
				justify-content: space-around;

				.title {
					font-size: 24px;
					font-weight: 400;
					color: #08243c;
					line-height: 24px;
				}

				.item {
					.agreement {
						font-size: 12px;
						font-weight: 400;
						color: #000000;
						line-height: 36px;
					}

					.login {
						width: 133px;
						height: 48px;
						background: #08243c;
						border-radius: 24px;
						font-size: 16px;
						font-weight: 400;
						color: #ffffff;
					}
				}

				.sanfang {
					font-size: 12px;
					font-weight: 400;
					color: #888888;
					line-height: 12px;
				}

				.wx {
					text-align: center;
					cursor: pointer;
				}
			}
		}

		.title-box {
			font-size: 24px;
			font-weight: 400;
			color: #08243c;
			line-height: 24px;
			text-align: center;
		}

		.title-box::after {
			content: "";
			width: 206px;
			height: 1px;
			background: linear-gradient(-90deg, #ffffff, #08243c, #ffffff);
			display: block;
			margin: 25px auto;
		}

		.content {
			padding: 40px;
			font-size: 18px;
			font-weight: 400;
			color: #08243c;
			line-height: 36px;
		}
	}

	.ico {
		position: absolute;
		top: 50%;
		transform: translate(0, -50%);
	}

	/deep/.el-input__inner {
		border: none;
		border-bottom: 1px solid #08243c;
		border-radius: 0;
	}

	/deep/.el-input__suffix {
		display: flex;
		align-items: center;
		padding-right: 12px;
	}

	.second {
		font-size: 14px;
		font-weight: 400;
		color: #e66617;
		line-height: 14px;
		cursor: pointer;
	}
</style>